import { Route, Routes } from "react-router-dom";
import { InterProcessorTransfers } from "../../pages";

export const InterProcessorTransfersLayout = () => {
  return (
    <Routes>
      <Route path="/*" element={<InterProcessorTransfers />} />
      {/* <Route path="/processor-balances" element={<ProcessorBalances />} /> */}
    </Routes>
  );
};
